import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'


export const DropDownFilterSingle = ({ title, addSubTitle = true, subTitle, options, state, setState }) => {

    const onChange = (value) => {
        setState(value);
    };

    return (
        <div className="flex w-full text-center justify-center">
            <Menu as="div" className="w-full relative inline-block text-left">
                <div>
                    <Menu.Button className={`inline-flex w-full justify-center items-center rounded-md bg-white px-4 py-2 text-md font-medium text-gray-700 shadow-sm ring-1 ring-inset ${state ? 'ring-gray-400 text-gray-900' : 'ring-gray-300'} hover:bg-gray-50 hover:text-gray-900 hover:ring-gray-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2`}>
                        {addSubTitle && subTitle && state && (
                            <span className="text-gray-700 mr-1">
                                {subTitle}:
                            </span>
                        )}  
                        {state ? `${options.find(option => option.value === state)?.label}` : title}
                        <ChevronDownIcon
                            className="-mr-1 ml-2 h-5 w-5 text-gray-500"
                            aria-hidden="true"
                        />
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="absolute right-0 mt-2 w-full md:w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none z-50">
                        <div className="px-2 py-1">
                            {
                                options.map(option => (

                                    <Menu.Item key={option.value} className="flex justify-center">
                                        {({ active }) => (
                                            <button
                                                className={`${option.value === state
                                                    ? 'bg-indigo-600 text-white ring-1 ring-inset ring-indigo-500'
                                                    : active
														? 'bg-gray-50 text-gray-800 ring-1 ring-inset ring-gray-200'
                                                        : 'bg-white text-gray-700 ring-1 ring-inset ring-transparent'
                                                    } group flex w-full items-center rounded-md px-2 py-2 text-md my-2 transition`}
                                                onClick={() => onChange(option.value)}
                                            >
                                                {option.label}
                                            </button>
                                        )}
                                    </Menu.Item>
                                ))
                            }
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    )
}